export const GET_ACCESS_BUILDINGS = 'GET_ACCESS_BUILDINGS';
export const IS_FETCHING = 'IS_FETCHING';
export const ERROR_SERVER = 'ERROR_SERVER';
export const SET_ACCESS_BUILDINGS = 'SET_ACCESS_BUILDINGS';
export const SET_ACCESS_BUILDING_SEARCHABLE = 'SET_ACCESS_BUILDING_SEARCHABLE';